import React from 'react';
export function UrgencySection() {
  return <section className="py-24 px-4 bg-black text-white text-center border-y-8 border-red-600" data-id="element-205">
      <div className="max-w-4xl mx-auto" data-id="element-206">
        <h2 className="text-4xl md:text-5xl font-black text-gray-400 mb-12 uppercase tracking-wide" data-id="element-207">
          La mayoría de la gente:
        </h2>

        <div className="space-y-4 text-2xl md:text-4xl font-bold text-gray-500 mb-16" data-id="element-208">
          <p data-id="element-209">⏳ Sigue consumiendo contenido</p>
          <p data-id="element-210">⏳ Sigue aprendiendo</p>
          <p data-id="element-211">⏳ Sigue esperando</p>
        </div>

        <h3 className="text-4xl md:text-6xl font-black text-white mb-12 uppercase" data-id="element-212">
          Mientras otros…
        </h3>

        <div className="space-y-6 text-3xl md:text-5xl font-black text-yellow-400 mb-20" data-id="element-213">
          <p className="transform hover:scale-105 transition-transform" data-id="element-214">
            👉 Ejecutan
          </p>
          <p className="transform hover:scale-105 transition-transform" data-id="element-215">
            👉 Venden
          </p>
          <p className="transform hover:scale-105 transition-transform" data-id="element-216">
            👉 Crecen
          </p>
        </div>

        <div className="bg-red-600 p-8 md:p-12 rounded-2xl transform -rotate-1 shadow-2xl" data-id="element-217">
          <p className="text-3xl md:text-4xl font-black text-white uppercase mb-4" data-id="element-218">
            La diferencia no es información.
          </p>
          <p className="text-6xl md:text-8xl font-black text-yellow-300 uppercase" data-id="element-219">
            Es acción.
          </p>
        </div>
      </div>
    </section>;
}